import { MasterShell } from "@/shared/layouts/MasterShell.jsx";
import { UsersManager } from "@/features/users/UsersManager.jsx";
import { PLATFORM_ROLE_OPTIONS } from "@/shared/lib/roles.js";

/**
 * Equipe OdontoPlug.
 *
 * Reaproveita o mesmo `UsersManager` da tela da clínica, só mudando o
 * escopo e a lista de perfis. No app antigo esta tela tinha código próprio
 * que gravava a senha em texto puro na tabela `master_users`.
 */
export function MasterUsersPage() {
  return (
    <MasterShell title="Usuários Master" subtitle="Equipe com acesso ao painel administrativo">
      <UsersManager escopo="master" roleOptions={PLATFORM_ROLE_OPTIONS} />
    </MasterShell>
  );
}
